import virtualCard from "../../assets/images/virtual_card.jpeg";
import physicalCard from "../../assets/images/nova_card.png";

export const cardAssets = {
  virtual: virtualCard,
  physical: physicalCard,
};

export const adminMetrics = {
  purchasedCards: 4280,
  kycSubmitted: 312,
  kycPending: 84,
  kycApproved: 196,
  kycRejected: 32,
  virtualSubscribers: 1840,
  physicalSubscribers: 620,
  totalSubscribers: 2460,
  invitedFriends: 518,
  todayTransactions: 94,
  weeklyTransactions: 1345,
  monthlyTransactions: 3982,
  totalTransactions: 18452,
  todayAmount: 28450,
  totalAmount: 4829450,
  weeklySummary: {
    incomePercent: 30,
    expensePercent: 46,
    unknownPercent: 10,
  },
};

export const kycRecords = [
  {
    id: "KYC-1001",
    name: "Ayesha Khan",
    email: "ayesha.khan@nova.com",
    phone: "+92 312 555 0143",
    status: "Submitted",
    submittedAt: "2026-01-20 10:35",
    documentType: "CNIC",
    documentId: "35202-4567891-3",
    riskScore: "Low",
  },
  {
    id: "KYC-1002",
    name: "Bilal Qureshi",
    email: "bilal.q@nova.com",
    phone: "+92 321 111 4489",
    status: "Pending",
    submittedAt: "2026-01-21 09:10",
    documentType: "Passport",
    documentId: "PK-8934211",
    riskScore: "Medium",
  },
  {
    id: "KYC-1003",
    name: "Nida Arif",
    email: "nida.arif@nova.com",
    phone: "+92 333 908 2240",
    status: "Approved",
    submittedAt: "2026-01-18 14:42",
    documentType: "CNIC",
    documentId: "42101-7723112-1",
    riskScore: "Low",
  },
  {
    id: "KYC-1004",
    name: "Usman Latif",
    email: "usman.latif@nova.com",
    phone: "+92 300 221 8190",
    status: "Rejected",
    submittedAt: "2026-01-17 11:05",
    documentType: "CNIC",
    documentId: "37405-1188771-0",
    riskScore: "High",
  },
  {
    id: "KYC-1005",
    name: "Sara Malik",
    email: "sara.malik@nova.com",
    phone: "+92 334 555 6301",
    status: "Approved",
    submittedAt: "2026-01-16 16:25",
    documentType: "Passport",
    documentId: "PK-2389013",
    riskScore: "Low",
  },
  {
    id: "KYC-1006",
    name: "Hamza Iqbal",
    email: "hamza.iqbal@nova.com",
    phone: "+92 345 220 7789",
    status: "Pending",
    submittedAt: "2026-01-22 13:18",
    documentType: "CNIC",
    documentId: "61101-4047892-2",
    riskScore: "Medium",
  },
  {
    id: "KYC-1007",
    name: "Hina Noor",
    email: "hina.noor@nova.com",
    phone: "+92 301 778 1129",
    status: "Submitted",
    submittedAt: "2026-01-22 15:42",
    documentType: "CNIC",
    documentId: "35202-2258911-8",
    riskScore: "Low",
  },
];

export const cardSubscriptions = [
  {
    id: "SUB-2001",
    name: "Ayesha Khan",
    type: "Virtual",
    plan: "Nova Starter",
    fee: 10,
    status: "Active",
    subscribedAt: "2025-12-18",
  },
  {
    id: "SUB-2002",
    name: "Bilal Qureshi",
    type: "Physical",
    plan: "Nova Prime",
    fee: 70,
    status: "Active",
    subscribedAt: "2025-12-10",
  },
  {
    id: "SUB-2003",
    name: "Sara Malik",
    type: "Virtual",
    plan: "Nova Prime",
    fee: 10,
    status: "Paused",
    subscribedAt: "2025-11-28",
  },
  {
    id: "SUB-2004",
    name: "Hina Noor",
    type: "Physical",
    plan: "Nova Elite",
    fee: 70,
    status: "Active",
    subscribedAt: "2025-12-01",
  },
];

export const cardInventory = [
  {
    id: "CARD-01",
    name: "Nova Virtual",
    type: "Virtual",
    fee: 10,
    status: "Available",
    image: cardAssets.virtual,
  },
  {
    id: "CARD-02",
    name: "Nova Physical",
    type: "Physical",
    fee: 70,
    status: "Available",
    image: cardAssets.physical,
  },
];

export const transactions = [
  {
    id: "TXN-31001",
    user: "Ayesha Khan",
    type: "Card Purchase",
    amount: 1299,
    status: "Success",
    channel: "Card",
    date: "2026-01-22 10:05",
  },
  {
    id: "TXN-31002",
    user: "Bilal Qureshi",
    type: "Card Fee",
    amount: 499,
    status: "Success",
    channel: "Wallet",
    date: "2026-01-22 09:48",
  },
  {
    id: "TXN-31003",
    user: "Nida Arif",
    type: "Card Topup",
    amount: 2200,
    status: "Pending",
    channel: "Bank Transfer",
    date: "2026-01-22 08:33",
  },
  {
    id: "TXN-31004",
    user: "Usman Latif",
    type: "Card Fee",
    amount: 699,
    status: "Failed",
    channel: "Wallet",
    date: "2026-01-21 18:25",
  },
  {
    id: "TXN-31005",
    user: "Hina Noor",
    type: "Card Purchase",
    amount: 1899,
    status: "Success",
    channel: "Card",
    date: "2026-01-21 16:11",
  },
];

export const invites = [
  {
    id: "INV-01",
    inviter: "Ayesha Khan",
    inviterEmail: "ayesha.khan@nova.com",
    invitee: "Sami Ali",
    inviteeEmail: "sami.ali@nova.com",
    status: "Joined",
    date: "2026-01-15",
  },
  {
    id: "INV-02",
    inviter: "Ayesha Khan",
    inviterEmail: "ayesha.khan@nova.com",
    invitee: "Huda Riaz",
    inviteeEmail: "huda.riaz@nova.com",
    status: "Pending",
    date: "2026-01-19",
  },
  {
    id: "INV-03",
    inviter: "Ayesha Khan",
    inviterEmail: "ayesha.khan@nova.com",
    invitee: "Amir Sheikh",
    inviteeEmail: "amir.sheikh@nova.com",
    status: "Joined",
    date: "2026-01-21",
  },
  {
    id: "INV-04",
    inviter: "Bilal Qureshi",
    inviterEmail: "bilal.q@nova.com",
    invitee: "Danish Noor",
    inviteeEmail: "danish.noor@nova.com",
    status: "Joined",
    date: "2026-01-12",
  },
  {
    id: "INV-05",
    inviter: "Bilal Qureshi",
    inviterEmail: "bilal.q@nova.com",
    invitee: "Zoya Malik",
    inviteeEmail: "zoya.malik@nova.com",
    status: "Pending",
    date: "2026-01-18",
  },
  {
    id: "INV-06",
    inviter: "Sara Malik",
    inviterEmail: "sara.malik@nova.com",
    invitee: "Aliya Zafar",
    inviteeEmail: "aliya.zafar@nova.com",
    status: "Joined",
    date: "2026-01-09",
  },
  {
    id: "INV-07",
    inviter: "Sara Malik",
    inviterEmail: "sara.malik@nova.com",
    invitee: "Noor Hassan",
    inviteeEmail: "noor.hassan@nova.com",
    status: "Joined",
    date: "2026-01-20",
  },
  {
    id: "INV-08",
    inviter: "Hina Noor",
    inviterEmail: "hina.noor@nova.com",
    invitee: "Waqas Ahmed",
    inviteeEmail: "waqas.ahmed@nova.com",
    status: "Pending",
    date: "2026-01-22",
  },
  {
    id: "INV-09",
    inviter: "Hina Noor",
    inviterEmail: "hina.noor@nova.com",
    invitee: "Farah Iqbal",
    inviteeEmail: "farah.iqbal@nova.com",
    status: "Joined",
    date: "2026-01-23",
  },
  {
    id: "INV-10",
    inviter: "Usman Latif",
    inviterEmail: "usman.latif@nova.com",
    invitee: "Rizwan Ali",
    inviteeEmail: "rizwan.ali@nova.com",
    status: "Joined",
    date: "2026-01-11",
  },
  {
    id: "INV-11",
    inviter: "Usman Latif",
    inviterEmail: "usman.latif@nova.com",
    invitee: "Iqra Shah",
    inviteeEmail: "iqra.shah@nova.com",
    status: "Pending",
    date: "2026-01-16",
  },
  {
    id: "INV-12",
    inviter: "Sara Malik",
    inviterEmail: "sara.malik@nova.com",
    invitee: "Fahad Amin",
    inviteeEmail: "fahad.amin@nova.com",
    status: "Joined",
    date: "2026-01-24",
  },
];

export const profileData = {
  name: "NOVA Admin",
  role: "Super Admin",
  email: "admin@nova.com",
  phone: "+92 300 555 0110",
  location: "Islamabad, Pakistan",
  joinedAt: "2024-04-01",
  lastLogin: "2026-01-22 09:05",
};
